import NewQuoteBlock from '../components/NewQuoteBlock';

export default function CreateNewPage() {
  return (
    <div className='page'>
      <NewQuoteBlock />
    </div>
  );
}
